export const PRODUCT_IPRO_WITH_AZ = [
  {
    ipro: 'life-ready',
    azCode: 'W99FU18',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/life-ready',
  },
  {
    ipro: 'shechillsafesure',
    azCode: 'W99FU18',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/life-ready',
  },
  {
    ipro: 'iwealthy',
    azCode: 'RPUL',
    categoryId: 'CATEGORY_EDUCATION',
    categoryPath: '/investment',
  },
  {
    ipro: 'iinvest',
    azCode: 'SPUL',
    categoryId: 'CATEGORY_EDUCATION',
    categoryPath: '/investment',
  },
  {
    ipro: 'ilink',
    azCode: 'RPUDR',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/investment',
  },
  {
    ipro: 'ishield',
    azCode: 'WLCI05',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'icare',
    azCode: 'ICARE',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/protection',
  },
  {
    ipro: '12pl',
    azCode: '12PL',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'protection-life-5',
    azCode: 'PLB05',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'protection-life-10',
    azCode: 'PLB10',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'protection-life-12',
    azCode: 'PLB12',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'protection-life-15',
    azCode: 'PLB15',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'super-7-criticalcare-1pay',
    azCode: 'CIWLS39',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'super-7-criticalcare-3pay',
    azCode: 'CIWLM39',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/whole-life',
  },
  {
    ipro: 'life-super-save-14-5',
    azCode: 'S14G5T1',
    categoryId: 'CATEGORY_EDUCATION',
    categoryPath: '/term-life',
  },
  {
    ipro: 'ultimate-growth',
    azCode: 'E20F10',
    categoryId: 'CATEGORY_EDUCATION',
    categoryPath: '/term-life',
  },
  {
    ipro: 'bumnan-ready',
    azCode: 'R08F',
    categoryId: 'CATEGORY_RETIREMENT',
    categoryPath: '/bumnan-ready',
  },
  {
    ipro: 'shechillfeelgood',
    azCode: 'R08F',
    categoryId: 'CATEGORY_RETIREMENT',
    categoryPath: '/bumnan-ready',
  },
  {
    ipro: 'ismart80-6',
    azCode: 'W80F06',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/term-life',
  },
  {
    ipro: 'life-treasure',
    azCode: 'H99F18A',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/life-ready',
  },
  {
    ipro: 'pa-classic',
    azCode: 'PA_CLASSIC',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/personal-accident',
  },
  {
    ipro: 'pa-platinum',
    azCode: 'PA_PLATINUM',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/personal-accident',
  },
  {
    ipro: 'pa-max',
    azCode: 'PA_MAX',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/personal-accident',
  },
  {
    ipro: 'life-ultra-save-10-3',
    azCode: 'E10G3A',
    categoryId: 'CATEGORY_RETIREMENT',
    categoryPath: '/term-life',
  },
  {
    ipro: 'rokeraisoshield',
    azCode: 'ROKE-RAI-SO-SHIELD-W99FH99',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/term-life',
  },
  {
    ipro: 'global-index-16-6',
    azCode: 'E16G6A',
    categoryId: 'CATEGORY_RETIREMENT',
    categoryPath: '/term-life',
  },
  {
    ipro: 'bumnan-smart-95',
    azCode: 'R9506M1',
    categoryId: 'CATEGORY_RETIREMENT',
    categoryPath: '/bumnan-ready',
  },
  {
    ipro: 'double-shield-health-combo',
    azCode: 'COMBO-HEALTH-ESSENTIAL-WLF99H',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'global-saving-plus-25-5-index-linked',
    azCode: 'E25G5A',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/index-linked',
  },
  {
    ipro: 'global-saving-plus-15-8-index-linked',
    azCode: 'E15G8A',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/index-linked',
  },
  {
    ipro: 'easy-protect-6',
    azCode: 'W99F06A',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/life-ready',
  },
  {
    ipro: 'life-protect-plus',
    azCode: 'WLF09L',
    categoryId: 'CATEGORY_PROTECTION',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'health-ultra-package',
    azCode: 'HEALTH-ULTRA-PACKAGE-WLF99HX',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'health-extra-package',
    azCode: 'HEALTH-EXTRA-PACKAGE-WLF99HX',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'rokeraisoshield-product',
    azCode: 'ROKE-RAI-SO-SHIELD-WLF99H',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'ci-product',
    azCode: 'KOOMVER-ROKE-RAI-1-WLF99H',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
  {
    ipro: 'meb-product',
    azCode: 'KOOMVER-COMPENSATE-1-WLF99H',
    categoryId: 'CATEGORY_RECOMMEND',
    categoryPath: '/life-protect-plus',
  },
]
